import {
  Component,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { EPage } from '../direct-ticket-configuration-shopping-cart/direct-ticket-configuration-shopping-cart.component';
import {
  EEntityType,
  ERelationType,
  ITicket,
  NamedTariffProductDefinition,
} from '@web/dtos';
import { TicketFrameComponent } from '../../data-display/ticket-frame/ticket-frame.component';
import { CorporateDesignService } from '../../../services/corporate-design/corporate-design.service';
import { FilterTextsPipe } from '../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../pipes/language/language.pipe';
import { ShoppingCartHeadline } from '../../data-display/shopping-cart-headline/shopping-cart-headline.component';
import { ShoppingCartEmpty } from '../../data-display/shopping-cart-empty/shopping-cart-empty';
import { NgTemplateOutlet } from '@angular/common';
import { SubscriptionConfigStore } from '../../../services/api/subscription/subscription-config-store.service';
import { ButtonComponent } from '../button/button.component';
import { WebTextStore } from '../../../services/api/text/web-text-store.service';

@Component({
  selector: 'aw-subscription-ticket-shopping-cart',
  imports: [
    TicketFrameComponent,
    FilterTextsPipe,
    LanguagePipe,
    ShoppingCartHeadline,
    ShoppingCartEmpty,
    NgTemplateOutlet,
    ButtonComponent,
  ],
  templateUrl: './subscription-ticket-shopping-cart.html',
})
export class SubscriptionTicketShoppingCart {
  public readonly page: InputSignal<EPage> = input.required();
  public readonly onButtonClick: OutputEmitterRef<void> = output();
  public readonly onSubmenuClick: OutputEmitterRef<{
    ticket: ITicket | undefined;
    productDefinition: NamedTariffProductDefinition;
  }> = output();
  protected readonly corporateDesignService: CorporateDesignService = inject(
    CorporateDesignService
  );
  protected readonly textStore: WebTextStore = inject(WebTextStore);
  protected readonly subscription: SubscriptionConfigStore = inject(
    SubscriptionConfigStore
  );
  protected readonly ERelationType: typeof ERelationType = ERelationType;
  protected readonly EEntityType: typeof EEntityType = EEntityType;
}
